export interface MerchantLink {
    id: number;
    name: string;
    url: string;
    status?: 'new' | 'changed' | 'unchanged';
}

export function stripStatus(merchantLink: MerchantLink) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- destructuring assignment to remove specific status property
    const { status, ...linkWithoutStatus } = merchantLink;
    return linkWithoutStatus;
}